export default __webpack_public_path__ + "static/media/moneyImage.2d940ec5.jpg";